import React from 'react'
import _ from 'lodash'
import { usePromise } from '../../../modules/hookUtils'
import {
  fetchTowns,
  fetchListings,
  updateScore,
} from '../../../modules/portal-remote/portalService'

export function updateTownScore(townScores) {
  return updateScore('town', townScores)
}

export function updateListingScore(listingScores) {
  return updateScore('listing', listingScores)
}

export default function WebAdminPage() {
  const [result, setResult] = React.useState({})
  const [user, setUser] = React.useState({})

  function handleScoreChange(key, scores) {
    setResult({ ...result, [key]: scores })
  }

  function handleSubmit() {
    const promises = []
    if (result.towns) {
      promises.push(updateTownScore(result.towns))
    }

    if (result.listings) {
      promises.push(updateListingScore(result.listings))
    }

    Promise.all(promises)
      .then(() => {
        window.alert('submit success !!')
        setResult({})
      })
      .catch(error => {
        window.alert('submit err:' + error.message)
      })
  }

  function handleUserChange(user) {
    setUser(user)
  }

  return (
    <div style={{ marginTop: 56 }} className="section">
      <hr />
      {user && (
        <div>
          <div className="columns">
            <div className="column">
              <div className="title">WELCOME ADMIN</div>
            </div>
            <div className="column ">
              <div className="field is-grouped is-pulled-right">
                <div className="control">
                  <div className="button is-primary" onClick={handleSubmit}>
                    SAVE
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="columns">
            <div className="column">
              <TownPanel onScoreChange={handleScoreChange} />
            </div>
            <div className="column">
              <ListingPanel onScoreChange={handleScoreChange} />
            </div>
          </div>

          {/* {JSON.stringify(result)} */}
          {/* {JSON.stringify(user)} */}
        </div>
      )}
    </div>
  )
}

function TownPanel({ onScoreChange }) {
  const { isLoading: isTownLoading, data: towns, setIsFetching } = usePromise(
    () => fetchTowns({ isUseInWeb: true }),
  )
  const [townScore, setTownScore] = React.useState({})
  function townScoreChange(id, score) {
    const _townScore = _.omitBy({ ...townScore, [id]: score }, _.isNaN)
    setTownScore(_townScore)
    onScoreChange('towns', _townScore)
  }

  function getTownScore(town) {
    let _townScore = _.get(townScore, town._id)
    _townScore = _.isNumber(_townScore) ? _townScore : _.get(town, 'score')
    return _townScore || 0
  }

  // function handleTownDelete(town) {
  //   removeTown(town.id)
  //     .then(() => {
  //       window.alert('remove town success')
  //       setIsFetching(true)
  //     })
  //     .catch(err => window.alert('remove error: ' + err.message))
  // }
  //delete part delete

  const townsWithSortByScore = _.sortBy(towns, [town => -getTownScore(town)])

  if (isTownLoading) {
    return <div>loading...</div>
  }

  return (
    <nav className="panel">
      <div className="panel-heading">TOWN</div>
      <div className="panel-block">
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Town Name</th>
              <th style={{ width: 150 }}>Score</th>
              {/* <th>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {_.map(townsWithSortByScore, town => (
              <tr key={town._id}>
                <td>{_.get(town, 'title.th')}</td>
                <td>
                  <input
                    type="number"
                    className="input"
                    value={getTownScore(town)}
                    onChange={e =>
                      townScoreChange(town._id, _.parseInt(e.target.value))
                    }
                  />
                </td>
                {/* <td>
                  <button
                    className="button is-danger heading"
                    onClick={() => handleTownDelete(town)}
                  >
                    Delete
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </nav>
  )
}

function ListingPanel({ onScoreChange }) {
  const {
    isLoading: isListingLoading,
    data: listings,
    setIsFetching,
  } = usePromise(() =>
    fetchListings({ isUseInWeb: true }).then(data =>
      _.orderBy(data, ['score'], ['asc']),
    ),
  )

  const [listingScore, setListingScore] = React.useState({})

  function listingScoreChange(id, score) {
    const _listingScore = _.omitBy({ ...listingScore, [id]: score }, _.isNaN)
    setListingScore(_listingScore)
    onScoreChange('listings', _listingScore)
  }

  function getListingScore(listing) {
    let _listingScore = _.get(listingScore, listing._id)
    _listingScore = _.isNumber(_listingScore)
      ? _listingScore
      : _.get(listing, 'score')
    return _listingScore || 0
  }

  function handleListingDelete(listing) {
    // removeListing(listing._id)
    //   .then(() => {
    //     window.alert('remove listing success');
    //     setIsFetching(true);
    //   })
    //   .catch(err => window.alert('remove error: ' + err.message));
  }

  const listingWithSortByScore = _.sortBy(listings, [
    listing => -getListingScore(listing),
  ])

  if (isListingLoading) {
    return <div>loading...</div>
  }

  return (
    <nav className="panel">
      <div className="panel-heading">Listing</div>
      <div className="panel-block">
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Listing Name</th>
              <th style={{ width: 150 }}>Score</th>
              {/* <th>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {_.map(listingWithSortByScore, listing => (
              <tr key={listing._id}>
                <td>
                  {_.get(listing, 'title.th')} <br />
                  <small style={{ color: 'gray' }}>
                    {_.get(listing, 'town')}
                  </small>
                </td>
                <td>
                  <input
                    type="number"
                    className="input"
                    value={getListingScore(listing)}
                    onChange={e =>
                      listingScoreChange(
                        listing._id,
                        _.parseInt(e.target.value),
                      )
                    }
                  />
                </td>
                {/* <td>
                  <button
                    className="button is-danger heading"
                    onClick={() => handleListingDelete(listing)}
                  >
                    Delete
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </nav>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/web/WebAdminPage.js